module.exports = __webpack_public_path__ + "static/media/missions.ff1a1ce0.png";